import { SchemeTypes } from '../../../../config';
import { LanguagesEnum } from '../../../../config/languages';

const CONFIGURATION = {
  MAX_WEBSITE_LENGTH: 250,
};

export const Translations = {
  form_error_required: {
    [LanguagesEnum.English]: 'This is required',
    [LanguagesEnum.Greek]: 'Υποχρεωτικό πεδίο',
  },
  contact_details_header: {
    [LanguagesEnum.English]: 'Contact Details',
    [LanguagesEnum.Greek]: 'Στοιχεία Επικοινωνίας',
  },
  first_name_label: {
    [LanguagesEnum.English]: 'First Name',
    [LanguagesEnum.Greek]: 'Όνομα',
  },
  surname_label: {
    [LanguagesEnum.English]: 'Surname',
    [LanguagesEnum.Greek]: 'Επίθετο',
  },
  address_street_label: {
    [LanguagesEnum.English]: 'Address Street',
    [LanguagesEnum.Greek]: 'Οδός',
  },
  number_label: {
    [LanguagesEnum.English]: 'Number',
    [LanguagesEnum.Greek]: 'Αριθμός',
  },
  postal_code_label: {
    [LanguagesEnum.English]: 'Postal Code',
    [LanguagesEnum.Greek]: 'Ταχυδρομικός Κώδικας',
  },
  city_label: {
    [LanguagesEnum.English]: 'City',
    [LanguagesEnum.Greek]: 'Πόλη',
  },
  country_label: {
    [LanguagesEnum.English]: 'Country',
    [LanguagesEnum.Greek]: 'Χώρα',
  },
  telephone_label: {
    [LanguagesEnum.English]: 'Telephone',
    [LanguagesEnum.Greek]: 'Τηλέφωνο',
  },
  website_label: {
    [LanguagesEnum.English]: 'Website',
    [LanguagesEnum.Greek]: 'Websites',
  },
  website_help: {
    [LanguagesEnum.English]:
      "Please provide the URL(s) of your Company's website(s)",
    [LanguagesEnum.Greek]: 'Προσθέστε τα URL(s) της εταιρείας σας',
  },
  invalid_phone_format: {
    [LanguagesEnum.English]: 'Invalid telephone format',
    [LanguagesEnum.Greek]: 'Invalid telephone format',
  },
  invalid_website_length: {
    [LanguagesEnum.English]: `The length of each website must not exceed ${CONFIGURATION.MAX_WEBSITE_LENGTH} characters`,
    [LanguagesEnum.Greek]: `The length of each website must not exceed ${CONFIGURATION.MAX_WEBSITE_LENGTH} characters`,
  },
};

export const CanModify = {
  [SchemeTypes.EU]: (is_agent?: boolean): string[] => {
    return [
      'contactDetails_firstName',
      'contactDetails_surname',
      'contactDetails_address',
      'contactDetails_number',
      'contactDetails_postalcode',
      'contactDetails_city',
      'contactDetails_country',
      'contactDetails_telephone',
      'contactDetails_email',
      'contactDetails_websites',
    ];
  },
  [SchemeTypes.NON_EU]: (is_agent?: boolean): string[] => {
    return [
      'contactDetails_firstName',
      'contactDetails_surname',
      'contactDetails_address',
      'contactDetails_number',
      'contactDetails_postalcode',
      'contactDetails_city',
      'contactDetails_country',
      'contactDetails_telephone',
      'contactDetails_email',
      'contactDetails_websites',
    ];
  },
  [SchemeTypes.IOSS]: (is_agent: boolean): string[] => {
    if (is_agent) {
      return [
        'contactDetails_firstName',
        'contactDetails_surname',
        'contactDetails_address',
        'contactDetails_number',
        'contactDetails_postalcode',
        'contactDetails_city',
        'contactDetails_country',
        'contactDetails_telephone',
        'contactDetails_email',
        'contactDetails_websites',
      ];
    } else {
      return [
        'contactDetails_firstName',
        'contactDetails_surname',
        'contactDetails_address',
        'contactDetails_number',
        'contactDetails_postalcode',
        'contactDetails_city',
        'contactDetails_country',
        'contactDetails_telephone',
        'contactDetails_email',
        'contactDetails_websites',
      ];
    }
  },
};
export default CONFIGURATION;
